export const capitalizeContactSentences = (value: string): string =>
  value.replace(/(^[\s"'«(]*|[.!?][\s"'«(]+|\n[\s"'«(]*)(\p{L})/gu,
    (_, prefix: string, letter: string) => prefix + letter.toLocaleUpperCase('it-IT'));

export const contactNominativeKey = (value: string): string =>
  value.normalize('NFKC').trim().replace(/\s+/g, ' ').toLocaleLowerCase('it-IT');
